// extracted by mini-css-extract-plugin
module.exports = {"favoriteBalloonNotice":"favoriteBalloonNotice","favoriteBalloonNotice__heading":"favoriteBalloonNotice__heading","favoriteBalloonNotice__text":"favoriteBalloonNotice__text"};